import src from "IMAGE";
export default { src, width: 374, height: 96, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ABsiXVgkLXpzHCNfWQ47WVYXRHVwGiFYUxohWlIQFDcyACkzioMuOZyVKzaSiR88gYgoO5GNKDKIgCIrdGskLXlwPWUS5LcDLNEAAAAASUVORK5CYII="};
